import { AccordionDetails, AccordionSummary } from '@mui/material';
import { styled } from '@mui/styles';
import { AddRounded, RemoveRounded } from '@mui/icons-material';
import { ReactElement, useState } from 'react';

// Core.
import { ITaxonomyTerm } from 'core/models';

// Styles.
import styles from './CommendationAccordion.module.scss';
import { StyledAccordion } from 'hooks/StyledComponents';

interface ICommendationAccordionProps {
  term: ITaxonomyTerm;
}

const StyledAccordionDetails = styled(AccordionDetails)({
  flexDirection: 'column',
  paddingBottom: 20,
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: 20,
});

export const CommendationAccordion = (props: ICommendationAccordionProps): ReactElement => {
  const { term } = props;
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <StyledAccordion key={term.id} onChange={() => setIsExpanded(!isExpanded)}>
      <AccordionSummary
        sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)', padding: '0 8px 0 0' }}
        expandIcon={isExpanded ? <RemoveRounded className={styles.icon} /> : <AddRounded className={styles.icon} />}
      >
        <strong className={styles.summary}>{term.name}</strong>
      </AccordionSummary>
      <StyledAccordionDetails>
        {term?.terms?.length ? (
          <ul className={styles.list}>
            {term.terms?.map((childTerm) => (
              <li key={childTerm.id}>
                <span>
                  <strong>{childTerm.name}</strong> - {childTerm.description}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <>{term.description}</>
        )}
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
